import { useEffect, useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import SearchBox from '@/components/feature/SearchBox';
import { allCategories } from '@/utils/news';

const navItems = [{ slug: '', name: '首页' }, ...allCategories.map((c) => ({ slug: c.slug, name: c.name }))];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  const today = new Date().toLocaleDateString('zh-CN', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    weekday: 'long',
  });

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `relative px-3 py-2 text-sm font-medium transition-colors whitespace-nowrap ${
      isActive ? 'text-primary-600' : 'text-foreground-700 hover:text-primary-600'
    }`;

  return (
    <header className="sticky top-0 z-50 w-full">
      <div className="hidden bg-primary-950 text-background-100 md:block">
        <div className="mx-auto flex max-w-page items-center justify-between px-4 py-1.5 text-xs md:px-6">
          <span className="flex items-center gap-2">
            <span className="inline-block h-1.5 w-1.5 rounded-full bg-accent-500 animate-pulse-dot"></span>
            实时热点更新中 · 数据为前端演示样例
          </span>
          <span className="flex items-center gap-4">
            <span className="text-background-300">{today}</span>
            <Link to="/about" className="text-background-200 transition-colors hover:text-accent-400">
              关于我们
            </Link>
          </span>
        </div>
      </div>

      <div className="border-b border-background-200 bg-background-50/95 backdrop-blur">
        <div className="mx-auto flex max-w-page items-center gap-4 px-4 py-3 md:px-6">
          <Link to="/" className="flex shrink-0 items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-lg text-background-50 dark:text-foreground-950">
              <i className="ri-fire-fill"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-xl font-bold text-primary-700">热搜榜</span>
              <span className="text-[10px] tracking-[0.25em] text-foreground-400">HOT SEARCH</span>
            </span>
          </Link>

          <nav className="ml-4 hidden items-center md:flex">
            {navItems.map((item) => (
              <NavLink key={item.slug} to={item.slug ? `/category/${item.slug}` : '/'} end={!item.slug} className={linkClass}>
                {item.name}
              </NavLink>
            ))}
          </nav>

          <div className="ml-auto hidden w-72 lg:block xl:w-80">
            <SearchBox />
          </div>

          <div className="ml-auto flex items-center gap-1 lg:ml-0">
            <button
              type="button"
              aria-label="搜索"
              onClick={() => setSearchOpen((v) => !v)}
              className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-700 transition-colors hover:bg-background-200 lg:hidden"
            >
              <i className="ri-search-line text-lg" title="搜索"></i>
            </button>
            <button
              type="button"
              aria-label="菜单"
              onClick={() => setMenuOpen(true)}
              className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-700 transition-colors hover:bg-background-200 md:hidden"
            >
              <i className="ri-menu-line text-xl" title="菜单"></i>
            </button>
          </div>
        </div>

        {searchOpen && (
          <div className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden">
            <SearchBox autoFocus />
          </div>
        )}
      </div>

      {menuOpen && (
        <div className="fixed inset-0 z-[60] md:hidden">
          <button
            type="button"
            aria-label="关闭菜单"
            onClick={() => setMenuOpen(false)}
            className="absolute inset-0 bg-foreground-950/50"
          ></button>
          <div className="absolute right-0 top-0 h-full w-72 max-w-[82%] bg-background-50 p-5 shadow-xl animate-fade-in">
            <div className="mb-6 flex items-center justify-between">
              <span className="font-heading text-lg font-bold text-primary-700">热搜榜</span>
              <button
                type="button"
                aria-label="关闭"
                onClick={() => setMenuOpen(false)}
                className="flex h-8 w-8 items-center justify-center rounded-md text-foreground-600 hover:bg-background-200"
              >
                <i className="ri-close-line text-xl" title="关闭"></i>
              </button>
            </div>
            <nav className="flex flex-col gap-1">
              {navItems.map((item) => (
                <button
                  key={item.slug}
                  type="button"
                  onClick={() => {
                    setMenuOpen(false);
                    navigate(item.slug ? `/category/${item.slug}` : '/');
                  }}
                  className="rounded-md px-3 py-3 text-left text-base font-medium text-foreground-800 transition-colors hover:bg-background-100 hover:text-primary-600"
                >
                  {item.name}
                </button>
              ))}
              <button
                type="button"
                onClick={() => {
                  setMenuOpen(false);
                  navigate('/about');
                }}
                className="rounded-md px-3 py-3 text-left text-base font-medium text-foreground-800 transition-colors hover:bg-background-100 hover:text-primary-600"
              >
                关于我们
              </button>
            </nav>
          </div>
        </div>
      )}
    </header>
  );
}